



























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import SettingsInfo from "./SettingsInfo.vue";
import SettingsUsers from "./SettingsUsers.vue";
import SettingsMydata from "./SettingsMydata.vue";
import SettingsGeneral from "./SettingsGeneral.vue";
import SettingsEvents from "./SettingsEvents.vue";
import SettingsRental from "./SettingsRental.vue";
import SettingsBirthdays from "./SettingsBirthdays.vue";
import SettingsNotifications from "./SettingsNotifications.vue";

import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Settings",
  components: {
    MainTabbar,
    SettingsInfo,
    SettingsUsers,
    SettingsMydata,
    SettingsGeneral,
    SettingsEvents,
    SettingsRental,
    SettingsBirthdays,
    SettingsNotifications,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    allActiveModules: Array as PropType<ModulesJson[]>,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      currentMainTabbarTab: "",
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },

    changeLoginData(loginName: string | null, loginPermission: number | null, loginPassword: string | null) {
      this.$emit("change-login-data", loginName, loginPermission, loginPassword);
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Info",
          linkedComponent: "SettingsInfo",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1),
          isDisplayed: vue.checkPermission(vue.loginUser, 1),
        },
        {
          title: "Benutzer:innen",
          linkedComponent: "SettingsUsers",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2),
          isDisplayed: vue.checkPermission(vue.loginUser, 2),
        },
        {
          title: "Meine Daten",
          linkedComponent: "SettingsMydata",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1),
          isDisplayed: vue.checkPermission(vue.loginUser, 1),
        },
        {
          title: "Allgemein",
          linkedComponent: "SettingsGeneral",
          permissionRank: 3,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 3),
          isDisplayed: vue.checkPermission(vue.loginUser, 3),
        },
        {
          title: "Veranstaltungen",
          linkedComponent: "SettingsEvents",
          permissionRank: 3,
          userPermission: null,
          isDisabled:
            !vue.checkModuleIsActivated(vue.userActiveModules, "Events") &&
            !vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleEvents),
          isDisplayed:
            vue.checkModuleIsActivated(vue.userActiveModules, "Events") &&
            vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleEvents),
        },
        {
          title: "Geburtstage",
          linkedComponent: "SettingsBirthdays",
          permissionRank: 3,
          userPermission: null,
          isDisabled:
            !vue.checkModuleIsActivated(vue.userActiveModules, "Birthdays") &&
            !vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleBirthdays),
          isDisplayed:
            vue.checkModuleIsActivated(vue.userActiveModules, "Birthdays") &&
            vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Verleih",
          linkedComponent: "SettingsRental",
          permissionRank: 3,
          userPermission: null,
          isDisabled:
            !vue.checkModuleIsActivated(vue.userActiveModules, "Rental") &&
            !vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleRental),
          isDisplayed:
            vue.checkModuleIsActivated(vue.userActiveModules, "Rental") &&
            vue.checkPermission(vue.loginUser, 3, UserPermissionType.moduleRental),
        },
        {
          title: "Benachrichtigungen",
          linkedComponent: "SettingsNotifications",
          permissionRank: 3,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 3),
          isDisplayed: vue.checkPermission(vue.loginUser, 3),
        },
      ] as ModulesJson[];
    },
  },
});
